module.exports = __webpack_public_path__ + "img/home.26bf5aaa.png";